import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';

const name = 'DASHBOARD_PLAN';

export const postChangePlan = createAsyncThunk(`${name}/POST_CHANGE_PLAN`,
  async ({vendorId, planId}, thunkApi) => {
    try {
      const response = await ApiService.post(`/challenge/vendor/admin/${vendorId}/plan/${planId}`, {});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getCurrentPlan = createAsyncThunk(`${name}/GET_CURRENT_PLAN`,
  async ({vendorId},thunkApi) => {
    try {
      const response = await ApiService.get(`/challenge/vendor/admin/${vendorId}/plan`);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getAvailablePlans = createAsyncThunk(`${name}/GET_AVAILABLE_PLANS`,
  async (thunkApi) => {
    try {
      const response = await ApiService.get('/challenge/plans');
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });


const initialState = {
  availablePlans: [],
  currentPlan: {},
};

export const dashboardPlanSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [getAvailablePlans.fulfilled]: (state, {payload}) => {
      state.availablePlans = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getAvailablePlans.rejected]: (state, {payload}) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getAvailablePlans.pending]: (state) => {
      state.isFetching = true;
    },
    [getCurrentPlan.fulfilled]: (state, {payload}) => {
      state.currentPlan = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getCurrentPlan.rejected]: (state, {payload}) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getCurrentPlan.pending]: (state) => {
      state.isFetching = true;
    },
    [postChangePlan.fulfilled]: (state, {payload}) => {
      state.isFetching = false;
      state.isFetched = true;
    },
    [postChangePlan.rejected]: (state, {payload}) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
  }
});
